import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as ItemNameShopAPI from "@/api/item-name-shop";
import { CommonResponse, isSuccess } from "@/api/response";
import { RegisterRequest } from "@/api/item-name-shop/request";

const MODULE_NAME = "item-name-shop/modify";

/**
 * 項目名設定登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const commonResponse = await ItemNameShopAPI.register(registerRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
